import { makeAuthenticatedApiCall } from './authApi';
import { handleApiResponse } from './userDataService';
import { AUTH_API_URL } from '../config/api';

const API_BASE_URL = AUTH_API_URL;

// Get user point history with pagination
export const getUserPointHistory = async (page = 1, limit = 10) => {
  try {
    console.log('getUserPointHistory called');
    // console.log('getUserPointHistory called with:', { page, limit });
    
    const response = await makeAuthenticatedApiCall(`${API_BASE_URL}/getUserPointHistory?page=${page}&limit=${limit}`, {
      method: 'GET',
    });

    // console.log('getUserPointHistory response:', response);
    return response;
  } catch (error) {
    console.error('getUserPointHistory error:', error);
    // Handle network errors specifically
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Koneksi internet bermasalah. Silakan periksa koneksi Anda.');
    }
    // Re-throw the error with the original message
    throw error;
  }
};

/** Expiring points summary + expired deduction history (paginated) */
export const getPointExpiry = async (historyPage = 1, historyLimit = 15) => {
  try {
    const qs = `history_page=${historyPage}&history_limit=${historyLimit}`;
    return await makeAuthenticatedApiCall(`${API_BASE_URL}/getPointExpiry?${qs}`, {
      method: 'GET',
    });
  } catch (error) {
    console.error('getPointExpiry error:', error);
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Koneksi internet bermasalah. Silakan periksa koneksi Anda.');
    }
    throw error;
  }
};

// Transform API response to match current UI format
export const transformPointHistoryData = (apiData) => {
  if (!apiData || !apiData.point_history) {
    return [];
  }

  return apiData.point_history.map(item => {
    const notes = item.catatan || '';
    const refunded = isPointRefundNote(notes);

    return {
      id: item.id,
      type: item.tipe == 1 ? 'earned' : 'used',
      title: getTransactionTitle(item.tipe, notes),
      description: notes || 'Transaksi poin',
      points: Number(item.point) * (item.tipe == 1 ? 1 : -1),
      date: formatDate(item.created_at),
      time: formatTime(item.created_at),
      location: 'Zoolyfe',
      icon: getTransactionIcon(item.tipe, notes),
      transactionId: item.id_transaction,
      pointRewardId: item.id_pointreward,
      refunded,
    };
  });
};

const isPointRefundNote = (notes) => {
  const text = String(notes || '').toLowerCase();
  return text.includes('pembatalan') || text.includes('refund');
};

const getTransactionTitle = (type, notes) => {
  if (isPointRefundNote(notes)) {
    return 'Poin dikembalikan';
  }
  if (type == 1) {
    if (notes?.toLowerCase().includes('scan qr')) return 'Scan QR';
    if (notes?.toLowerCase().includes('dari transaksi')) return 'Bonus pembelian';
    if (notes?.toLowerCase().includes('spinning wheel')) return 'Spinning Wheel';
    if (notes?.toLowerCase().includes('hexpod reward')) return 'Hexpod Reward';
    if (notes?.toLowerCase().includes('event')) return 'Event';
    return 'Poin masuk';
  }
  if (notes?.toLowerCase().includes('untuk transaksi')) return 'Diskon pembelian';
  return 'Poin digunakan';
};

const getTransactionIcon = (type, notes) => {
  if (isPointRefundNote(notes)) {
    return 'arrow-undo-outline';
  }
  if (type == 1) {
    return 'qr-code-outline';
  }
  return 'gift-outline';
};

// Helper function to format date
const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  } catch (error) {
    return new Date().toISOString().split('T')[0];
  }
};

// Helper function to format time
const formatTime = (dateString) => {
  try {
    const date = new Date(dateString);
    return date.toTimeString().split(' ')[0].substring(0, 5); // Returns HH:MM format
  } catch (error) {
    return '00:00';
  }
};